import { Box } from '@mui/material';
import React from 'react';
import Typography from '@ui/Typography';
import GlobalTheme from '../../theme';

export interface StudioCueProps {
  label: string;
  children: React.ReactNode;
  isActive?: boolean;
  showReset?: boolean;
  description?: string;
  displayDivider?: boolean;
  onReset?: () => void;
}

interface StudioCuePropsV2 {
  label: string;
  children: React.ReactNode;
}

const StudioCue = ({ label, children }: StudioCuePropsV2) => (
  <Box minHeight={GlobalTheme.spacing(8.5)}>
    <Box display="flex" flexDirection="column">
      <Box display="flex" justifyContent="space-between">
        <Typography variant="pSm" bold>
          {label}
        </Typography>
      </Box>
    </Box>
    <Box>{children}</Box>
  </Box>
);

export default StudioCue;
